import { cva } from 'class-variance-authority'

import { cn } from '@/lib/ui/style-helpers'

export const segmentedControlsVariants = cva(
  'group relative inline-flex h-8 items-center justify-center gap-1 rounded border border-transparent px-2 text-label-default transition-all duration-150 disabled:pointer-events-none',
  {
    variants: {
      selected: {
        false: cn(
          'text-main-foreground-tertiary',
          'hover:bg-palette-opacity-gray-light',
          'hover:text-main-foreground-primary',
          'disabled:text-main-foreground-disabled',
        ),
        true: cn(
          'border-main-border-default',
          'bg-main-background-card',
          'text-main-foreground-primary',
          'shadow',
          'disabled:text-main-foreground-disabled',
        ),
      },
    },
    defaultVariants: {
      selected: false,
    },
  },
)

export const segmentedControlsIconVariants = cva(
  'flex !size-4 items-center justify-center group-disabled:text-main-foreground-disabled',
  {
    variants: {
      selected: {
        true: 'text-main-foreground-primary [&_svg]:text-current',
        false: '',
      },
    },
    defaultVariants: {
      selected: false,
    },
  },
)

export const segmentedControlsCounterVariants = cva(
  'inline-flex h-5 min-w-5 items-center justify-center rounded bg-palette-opacity-gray-light p-1 text-label-small text-main-foreground-secondary',
)
